<template>
    <v-form ref="client-specialist-form" v-model="isValid" @input="handleFormInput">
        <v-text-field
                v-model="sp.name"
                label="Name"
                :rules="nameRules"
                required
                :errorMessages="errorMessagesByFields['name']"
                @input="handleFieldInput($event, 'name')"
        ></v-text-field>
        <v-text-field
                v-model="sp.position"
                label="Position"
                :errorMessages="errorMessagesByFields['position']"
                @input="handleFieldInput($event, 'position')"
        ></v-text-field>
        <v-text-field
                v-model="sp.phone"
                label="Phone"
                :errorMessages="errorMessagesByFields['phone']"
                @input="handleFieldInput($event, 'phone')"
        ></v-text-field>
        <v-text-field
                v-model="sp.email"
                label="Email"
                :errorMessages="errorMessagesByFields['email']"
                @input="handleFieldInput($event, 'email')"
        ></v-text-field>
        <v-textarea
                v-model="sp.comment"
                label="Comment"
                :errorMessages="errorMessagesByFields['comment']"
                @input="handleFieldInput($event, 'comment')"
                auto-grow
        ></v-textarea>
        <v-checkbox v-model="sp.ex"
                    label="Ex"
        ></v-checkbox>
    </v-form>
</template>

<script>
    import _ from 'lodash'
    import {mapState} from 'vuex'
    import {validateStringLength} from '../../../helpers/validation'

    const emptyClientSpecialist = {
        id: null,
        name: null,
        position: null,
        phone: null,
        email: null,
        comment: null,
        ex: false
    }

    export default {
        name: "ClientForm",
        props: {
          clientSpecialist: Object,
          errorMessagesByFields: {
              type: Object,
              default: () => {
                  return {}
              }
          }
        },
        data () {
            return {
                sp: !this.clientSpecialist ? _.cloneDeep(emptyClientSpecialist) : _.cloneDeep(this.clientSpecialist),
                nameRules: [
                    v => !!v || 'Enter specialist name',
                    _.partial(validateStringLength, _, 255, 'The length of the name should be no more than 255 characters')
                ],
                positionRules: [
                    _.partial(validateStringLength, _, 255, 'The length of the position should be no more than 255 characters')
                ],
                phoneRules: [
                    _.partial(validateStringLength, _, 100, 'The length of the position should be no more than 100 characters')
                ],
                emailRules: [
                    _.partial(validateStringLength, _, 100, 'The length of the email should be no more than 100 characters'),
                    function (value) {
                        if (!value) {
                            return true
                        }
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'Invalid e-mail.'
                    }
                ],
                commentRules: [
                    _.partial(validateStringLength, _, 1000, 'The length of the comment should be no more than 1000 characters')
                ],
                isValid: false
            }
        },
        computed: {
            ...mapState('clients', {
            })
        },
        methods: {
            getFormData () {
              return {
                  id: this.sp.id,
                  name: this.sp.name,
                  position: this.sp.position,
                  phone: this.sp.phone,
                  email: this.sp.email,
                  comment: this.sp.comment,
                  ex: this.sp.ex
              }
            },
            reset () {
                this.sp = !this.clientSpecialist ? _.cloneDeep(emptyClientSpecialist) : _.cloneDeep(this.clientSpecialist)
            },
            validate () {
                return this.$refs['client-specialist-form'].validate()
            },
            isFormValid () {
                return this.isValid
            },
            handleFormInput (value) {
                this.$emit('validation-changed', value)
            },
            handleFieldInput (value, fieldName) {
                this.$emit('fieldChanged', {
                    fieldName: fieldName,
                    value: value
                })
            }
        }
    }
</script>

<style scoped>

</style>